import React, { useState } from 'react'
import { ImFilePdf } from 'react-icons/im'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import DeleteArticle from '../DeleteArticle/DeleteArticle'
import { MdOutlineModeEdit } from 'react-icons/md'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../../../../entity/user/model/selector/getUserData/getUserData'
import { useDispatch } from 'react-redux'
import { getIssueById, updateArticle } from '../../../../entity/volumes/Volumes'
import CreateArticleModal from '../../../../components/CreateArticleModal/CreateArticleModal'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

const SingleArticle = ({ article }) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [editIsOpen, setEditIsOpen] = useState(false)
  const user = useSelector(getUserData, shallowEqual)
  const { issueId } = useParams()
  const { t, i18n } = useTranslation()

  const handleEditModal = () => {
    setEditIsOpen(prev => !prev)
  }

  const onEditArticle = async data => {
    if (article && data) {
      await dispatch(updateArticle({ articleId: article.id, articleData: data }))
      dispatch(getIssueById(issueId))
      handleEditModal()
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{article?.title ?? 'Moambe Journal Article'}</title>
        <meta
          name='description'
          content={article?.title ?? 'Scientific article from Moambe Journal'}
        />
        <meta property='og:title' content={article?.title ?? 'Moambe Journal Article'} />
        <meta
          property='og:description'
          content={article?.title ?? 'Scientific article from Moambe Journal'}
        />
        <meta property='og:type' content='article' />
        <meta property='og:url' content={`http://moambe.org.ge${location.pathname}`} />
        <meta property='og:site_name' content='Moambe Journal / მოამბე ჟურნალი' />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:title' content={article?.title ?? 'Moambe Journal Article'} />
        <meta
          property='twitter:description'
          content={article?.title ?? 'Scientific article from Moambe Journal'}
        />
        <meta
          name='keywords'
          content='scientific journal, academic research, moambe journal, georgian national academy of sciences'
        />
      </Helmet>
      <div key={article?.id} className='flex flex-col gap-1 mt-4'>
        {article?.section && (
          <div className='p-1 text-sm text-white bg-[#897056] rounded-sm w-fit text-wrap'>
            {i18n.language === 'ka' ? article?.section_ka : article?.section}
          </div>
        )}
        <p className='text-[#002336] m-0 text-xl flex flex-row items-center text-wrap'>
          {(i18n.language === 'ka' ? article?.title_ka : article?.title) ?? `NULL`}&nbsp;&nbsp;{' '}
          {user?.role === 'admin' && (
            <span className='flex flex-row gap-1'>
              <MdOutlineModeEdit
                className='hover:cursor-pointer hover:scale-105 transition-all text-[#002336]'
                onClick={handleEditModal}
              />
              <DeleteArticle articleId={article.id} />
            </span>
          )}
        </p>
        <div className='flex flex-row flex-wrap break-words w-full mb-2'>
          {(i18n.language === 'ka' ? article?.authors_ka : article?.authors)?.map(
            (author, index) => (
              <p key={index} className='text-[#002336] m-0 text-base mr-2'>
                {author}
              </p>
            ),
          )}{' '}
        </div>
        <div className='flex flex-row items-center gap-1.5'>
          <a
            href={article?.pdf_url ?? '#'}
            target='_blank'
            rel='noreferrer noopener'
            className={`flex flex-row wrap gap-1 items-center  ${
              article?.pdf_url ? 'text-[#002336]' : 'text-gray-400 hover:text-gray-400'
            }`}
          >
            <ImFilePdf color={article?.pdf_url ? 'red' : 'gray'} />
            <span>PDF</span>
          </a>
          |
          <span>
            <Link to={`${location?.pathname}/article/${article?.id}`}>
              {t('volume.Abstract & References in HTML')}
            </Link>
          </span>
        </div>
      </div>
      {editIsOpen && (
        <CreateArticleModal
          isOpen={editIsOpen}
          onClose={handleEditModal}
          data={article}
          onSubmit={onEditArticle}
        />
      )}
    </>
  )
}

export default SingleArticle
